import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { CommanderThunkAction } from '@mews-commander/types';

export const getModalScrollableElement = (container: HTMLElement | null) => {
    if (!container) {
        return;
    }

    /**
     * Most pages have their main scrollable content located inside a div with .modal-body class.
     * Reports are different, as apart from the report content they also have a filters sidebar
     * that is also located in .modal-body but should not be scrolled. To fix this, a scrollable
     * element for reports is a different div with the .report-content class.
     */
    const reportContent = container.querySelector('.report-content');
    if (reportContent) {
        return reportContent;
    }

    return container.querySelector('.modal-body');
};

export const withActiveModalBody =
    (callback: (body: Element) => void): CommanderThunkAction =>
    () => {
        const activeModal = document.getElementById(DEFAULT_PORTAL_ID);
        if (activeModal) {
            const bodies = activeModal.getElementsByClassName('modal-body');
            if (bodies && bodies[0]) {
                callback(bodies[0]);
            }
        }
    };
